import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/native11-payment-method', { params })
    return response.data?.data || null
  },
  async getDetail(params){
    let response = await api.get('/admin/native11-payment-method/detail', { params })
    return response.data?.data?.document || null
  },
  async create(payload) {
    const response = await api.post('/admin/native11-payment-method', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/native11-payment-method', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/native11-payment-method', {
      data: payload,
    })
    return response
  },
}
